import { Button, Carousel, Tabs, Tooltip } from "flowbite-react";
import { useEffect, useState } from "react";
import Loader from "../Common/Loader";
import blankImage from "../../Assets/blank.png";
import { Link, useParams } from "react-router-dom";
import PartnerOpportunitiesApi from "../../Api/PartnerOpportunitiesApi";
import UserApi from "../../Api/UserApi";
import { opportunityDisplayHeading, PartnerOpportunityMyResponseDto } from "../../Models/PartnerOpportunity";
import { User } from "../../Models/User";
import { useAppSelector } from "../../Reducers/store";
import { UserLevelNames } from "../../Models/UserLevel";
import { HiPencilAlt, HiOutlineStar, HiStar } from "react-icons/hi";
import UserFavoriteApi from "../../Api/UserFavoriteApi";
import { MdEmail, MdLocalPhone, MdLocationPin } from "react-icons/md";
import DOMPurify from "isomorphic-dompurify";
import { FaRegCalendarCheck, FaRegCommentDots } from "react-icons/fa";
import UserEventsListTable from "./UserEventsListTable";
import { Event } from "../../Models/Event";
import EventApi from "../../Api/EventApi";
import { BsQrCode, BsPersonLock } from "react-icons/bs";
import UserUpdatePassword from "./UserUpdatePassword";

export default function UserProfile() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [userData, setUserData] = useState<User | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [favorite, setFavorite] = useState<boolean | null | undefined>(false);
  const [userEventList, setuserEventList] = useState<Event[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [partnerOppReplies, setPartnerOppReplies] = useState<PartnerOpportunityMyResponseDto[]>([]);

  const getUser = () => {
    if (id) {
      setIsLoading(true);
      UserApi.getUser(id)
        .then((res) => {
          setUserData(res.data);

          if (
            userModel?.userFavorites?.some(
              (x) => x.userFavoriteId === res.data?.id
            )
          ) {
            setFavorite(true);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setUserData(null);
    }
  };
  const getUserEventList = () => {
    if (id) {
      setIsLoading(true);
      EventApi.getUserEventList(id)
        .then((res) => {
          setuserEventList(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setUserData(null);
    }
  };

  useEffect(() => {
    getUser();
    getUserEventList();
  }, [id]);

  const iconstyle = { color: "#5b9d30" };

  function checkAccess() {
    if (userData && userModel && id) {
      if (userModel.userLevelId === UserLevelNames.SuperAdmin) {
        return true;
      } else if (
        userModel.memberId === userData.memberId &&
        userModel.id === Number(id)
      ) {
        return true;
      } else if (
        userModel.memberId === userData.memberId &&
        userModel.userLevelId === UserLevelNames.MemberAdmin
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
  const addFavorite = () => {
    if (userData) {
      if (favorite) {
        UserFavoriteApi.removeUserFavoriteUser(userData?.id?.toString());
      } else {
        UserFavoriteApi.addUserFavoriteUser(userData?.id?.toString());
      }
      setFavorite(!favorite);
    }
  };

  const downloadPdfNow = async (u: User) => {
    try {
      const response = await UserApi.getUserBadge(u.id);
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(pdfBlob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute(
        "download",
        `${u.firstName}_${u.lastName}_Badge.pdf`
      );

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  function checkAdminAccess() {
    if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div className="w-full">
      <div className="w-full p-4">
        <div className="mx-1 flex items-end">
          <div className="hidden md:flex flex-1">
            <h1 className="text-gray-900 font-bold text-4xl">
              User Information
            </h1>
          </div>
          {checkAccess() && (
            <>
              <div className="right-2">
                <Link to={`/edit/user/${userData?.id}`}>
                  <Tooltip content="Edit Details">
                    <Button className="buttonMain">
                      <HiPencilAlt size={20} />
                    </Button>
                  </Tooltip>
                </Link>
              </div>
              <div className="right-2">
                <Tooltip content="Update Password">
                  <Button className="buttonMain" onClick={() => setShow(true)}>
                    <BsPersonLock size={20} />
                  </Button>
                </Tooltip>
                <UserUpdatePassword
                  show={show}
                  setShow={setShow}
                  user={userData!}
                />
              </div>
            </>
          )}
          {checkAdminAccess() && userData && (
            <div className="right-2">
              <Tooltip content="Download Badge">
                <Button
                  className="buttonMainBlue"
                  onClick={() => downloadPdfNow(userData)}
                >
                  <BsQrCode size={20} />
                </Button>
              </Tooltip>
            </div>
          )}
          <div className="right-2">
            <Tooltip content="Toggle Favorite Status">
              <Button className="buttonMain" onClick={() => addFavorite()}>
                {favorite ? <HiStar size={20} /> : <HiOutlineStar size={20} />}
              </Button>
            </Tooltip>
          </div>
        </div>
      </div>

      <div>
        <div className="container mx-auto p-2">
          <div className="md:flex no-wrap md:-mx-2 ">
            {/* <!-- Left Side --> */}
            <div className="w-full md:w-2/12 md:mx-2">
              {/* <!-- Profile Card --> */}
              <div className="h-72 overflow-hidden rounded-md">
                <img src={userData?.image?.url ?? blankImage} alt="..." />
              </div>
              {/* <!-- End of profile card --> */}
            </div>
            {/* <!-- Right Side --> */}
            <div className="w-full md:w-10/12 mx-2">
              {" "}
              {/* <!-- Profile tab --> */}
              {/* <!-- About Section --> */}
              <div className="bg-white p-3">
                <div className="flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2">
                  <span className="tracking-wide uppercase text-3xl">
                    {userData?.firstName} {userData?.lastName}
                  </span>
                </div>
                <hr className="bg-gray-300 h-[5px]"></hr>
                <div className="text-gray-500">
                  <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                    <div className="flex">
                      <div className="px-1 content-center">
                        <MdLocalPhone style={iconstyle} />
                      </div>
                      <div className="font-bold">Phone:</div>
                    </div>
                    <div className="pl-1 text-mainButton">
                      {userData?.phoneNumber}
                    </div>
                  </div>
                  <hr className="bg-gray-300 h-[2px]"></hr>
                  <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                    <div className="flex">
                      <div className="px-1 content-center">
                        <MdEmail style={iconstyle} />
                      </div>
                      <div className="font-bold">Email:</div>
                    </div>
                    <div className="pl-1 text-mainButton">
                      {userData?.emailAddress}
                    </div>
                  </div>
                  <hr className="bg-gray-300 h-[2px]"></hr>
                  <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                    <div className="flex">
                      <div className="px-1 content-center">
                        <MdLocationPin style={iconstyle} />
                      </div>
                      <div className="font-bold">Address:</div>
                    </div>
                    <div className="pl-1 text-mainButton">
                      {userData?.address} {userData?.city}, {userData?.state}{" "}
                      {userData?.zip}
                    </div>
                  </div>
                  <hr className="bg-gray-300 h-[2px]"></hr>
                  <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                    <div className="flex">
                      {/* <div className='px-1 content-center'>
                        <FaSquareFacebook style={iconstyle} />
                      </div> */}
                      <div className="font-bold">User Level:</div>
                    </div>
                    <div className="pl-1 text-mainButton">
                      {userData?.userLevel?.name}
                    </div>
                  </div>
                  <hr className="bg-gray-300 h-[2px]"></hr>
                  <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                    <div className="flex">
                      {/* <div className='px-1 content-center'>
                        <FaTwitter style={iconstyle} />
                      </div> */}
                      <div className="font-bold">Bio:</div>
                    </div>
                    <div className="pl-1 text-mainButton whitespace-pre-line">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(userData?.bio ?? ""),
                        }}
                      />
                    </div>
                  </div>

                  {checkAccess() && (
                    <>
                      <hr className="bg-gray-300 h-[2px]"></hr>
                      <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                        <div className="flex">
                          <div className="font-bold">FEMA App Username:</div>
                        </div>
                        <div className="pl-1 text-mainButton whitespace-pre-line">
                          {userData?.femaAppUsername}
                        </div>
                      </div>
                      <hr className="bg-gray-300 h-[2px]"></hr>
                      <div className="grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl">
                        <div className="flex">
                          <div className="font-bold">FEMA App Password:</div>
                        </div>
                        <div className="pl-1 text-mainButton whitespace-pre-line">
                          {userData?.femaAppPassword}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {/* <!-- End of about section --> */}
              {/* <!-- End of profile tab --> */}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full p-3">
        <Tabs aria-label="Tabs with underline" style="underline">
          <Tabs.Item
            active
            title="Events"
            icon={FaRegCalendarCheck}
            className="font-bold"
          >
            <UserEventsListTable data={userEventList} />
          </Tabs.Item>
          {Number(id) === userModel?.id && (
            <Tabs.Item title="Opportunity replies" icon={FaRegCommentDots} className="font-bold">
              {partnerOppReplies.length === 0 ? (
                <p className="text-gray-600 text-sm">
                  You have not replied to any partner opportunities yet.
                </p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm text-left">
                    <thead>
                      <tr className="border-b border-gray-200">
                        <th className="py-2 pr-4 font-semibold text-gray-900">Date</th>
                        <th className="py-2 pr-4 font-semibold text-gray-900">Opportunity</th>
                        <th className="py-2 pr-4 font-semibold text-gray-900">Posted by</th>
                        <th className="py-2 pr-4 font-semibold text-gray-900">Your message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partnerOppReplies.map((r) => (
                        <tr key={r.responseId} className="border-b border-gray-100">
                          <td className="py-2 pr-4 whitespace-nowrap text-gray-700">
                            {new Date(r.dateCreated).toLocaleString()}
                          </td>
                          <td className="py-2 pr-4">
                            <Link className="text-blue-700 hover:underline" to="/partner-opportunities">
                              {opportunityDisplayHeading({
                                memberName: r.opportunityMemberName,
                                companyName: r.opportunityCompanyName,
                                seekingType: r.opportunitySeekingType,
                              }) || r.opportunityTitle}
                            </Link>
                          </td>
                          <td className="py-2 pr-4 text-gray-700">{r.opportunityMemberName}</td>
                          <td className="py-2 max-w-md text-gray-800 whitespace-pre-wrap">{r.message}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p className="text-xs text-gray-500 mt-3">
                    Browse and open listings on{" "}
                    <Link className="underline text-blue-700" to="/partner-opportunities">
                      Partner Opportunities
                    </Link>
                    .
                  </p>
                </div>
              )}
            </Tabs.Item>
          )}
        </Tabs>
      </div>
    </div>
  );
}
